








































import { Prop, ProvideReactive } from 'vue-property-decorator'
import { Component, mixins } from '@niknevis/vue-modules'
import QTable from 'quasar/src/components/table/QTable.js';
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsisOld.vue'
import { LatestNewsCollectionType } from '@/modules/news/models/news-collection.model'
import NewsCreate from '@/modules/news/components/admin/NewsCreate.vue'
import NewsEdit from '@/modules/news/components/admin/NewsEdit.vue'
import { QsPaginatableMixin } from '@/modules/shared/mixins/qs-paginatable.mixin'
import { QsSearchableMixin } from '@/modules/shared/mixins/qs-searchable.mixin'
import PaginationWithInput from '@/modules/shared/components/shared/pagination/PaginationWithInput.vue'
import AdminLayout from '@/modules/common/layout/components/admin/AdminLayout.vue'
import TesTable from '@/modules/common/tes-table/components/shared/TesTable.vue'
import { getNewsColumnsInAdmin } from '@/modules/news/models/news.column'
import AdminNewsRow from '@/modules/news/components/admin/table/AdminNewsRow.vue'
import FilterRow from '@/modules/common/filter/components/shared/layout/FilterRow.vue'

@Component({
  layout: AdminLayout,
  layoutProps: {
    page_header: 'آخرین اخبار'
  },
  metaInfo: {
    title: 'آخرین اخبار'
  },
  components: {
    TextEllipsis,
    DateTooltipped,
    NewsCreate,
    AdminLayout,
    TesTable,
    NewsEdit,
    FilterRow,
    PaginationWithInput
  }
})
export default class NewsPage extends mixins(QsPaginatableMixin, QsSearchableMixin) {

  @ProvideReactive()
  @Prop() news!: LatestNewsCollectionType

  protected columns: QTable['columns'] = getNewsColumnsInAdmin()
  private rowComponent = AdminNewsRow

  //paginate
  protected get model() {
    return this.news
  }

  private updatePage(page: number) {
    this.updateTable({
      pagination: {
        ...this.pagination,
        page
      }
    })
  }
}
